var __rspack_ns_object = JSON.parse('{"UU":"sb-bimtime","rE":"4.466.2"}')